/**
 * SFrame206 — General Creditor Distributions (checklist hub subsection).
 */

import { useParams } from 'react-router-dom';
import SettlementChecklistShell from '../settlement/SettlementChecklistShell';

const FRAME_ID = 'sframe-206';

const ITEMS = [
  {
    id: 'gc-1',
    title: 'Issue Pro-Rata Payments',
    description:
      'For insolvent estates, distribute available funds proportionally among creditors of equal priority.',
  },
  {
    id: 'gc-2',
    title: 'Settle Credit Cards & Personal Loans',
    description: 'Pay or negotiate settlement for all remaining unsecured consumer debts.',
  },
  {
    id: 'gc-3',
    title: 'Pay Medical & Utility Final Bills',
    description: 'Settle outstanding medical bills, utility final bills, and subscription cancellation fees.',
  },
];

export default function SFrame206() {
  const { estateId } = useParams<{ estateId: string }>();

  if (!estateId)
    return <div className="max-w-2xl mx-auto py-12 px-4 text-sm text-stone-600">Select an estate.</div>;

  return (
    <SettlementChecklistShell
      estateId={estateId}
      frameId={FRAME_ID}
      title="General Creditor Distributions"
      backTo={`/sframe-204/${estateId}`}
      backLabel="← Pay Validated Debts"
      items={ITEMS}
      payDebtsHubKey="s206"
    />
  );
}
